import * as React from 'react';
import { BaseComponentProps, BaseComponentState, BaseComponent } from '../base/BaseComponent';
import { SecurityData } from '../shared/index';
export interface OneDolarDepositProps  extends BaseComponentProps  {
    lang: string ;  
    user: SecurityData.ApplicationUser ; 
    user_login: boolean ;  
} 
export interface OneDolarDepositState  extends BaseComponentState  {}

export  class OneDolarDeposit extends BaseComponent<OneDolarDepositProps , OneDolarDepositState> {

	constructor(props: OneDolarDepositProps ) {
		super(props); 

	} 
  render() {
    if ( this.state.haveReactError ) {
        return this.renderErrorPanel() ; 
    } 
    return (
        <div className="col-md-9" style={{minHeight: 500}}>
            <h1>OneDolarDeposit</h1>
        </div>
        
    );
  }
} 
 


// WEBPACK FOOTER //
// ./src/my-account/OneDolarDeposit.tsx